import { styled } from 'styled-components'

import { parseError } from 'peach/helpers'

const Bar = styled.div`
  position: absolute;
  top: 8px;
  right: 12px;
  left: 12px;
  padding: 4px;
`

const Contents = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border: 1px solid red;
  border-radius: 3px;
  background-color: ${(p) => p.theme.offset};
  background-color: #fcc;
  padding: 8px 12px;
  white-space: pre-wrap;
  color: red;
`
const Message = styled.span`
  display: inline-block;
  font-size: 12px;
`

const ClearButton = styled.button`
  margin: 0;
  border: none;
  border-radius: 4px;
  background-color: transparent;
  cursor: pointer;
  padding: 4px 12px;
  color: red;
  font-size: 14px;

  &:hover {
    text-decoration: underline;
  }
`

const ModalErrorBar = ({ error, onClear }) => (
  <Bar>
    <Contents>
      <Message>{parseError(error)}</Message>
      <ClearButton onClick={onClear}>Clear</ClearButton>
    </Contents>
  </Bar>
)

export default ModalErrorBar
